import React from 'react';
import { TransitionGroup, Transition as ReactTransition } from 'react-transition-group';


const timeout = 500;
const getTransitionStyles = {
  entering: {
    position: 'absolute',
    opacity: 0,
  },
  entered: {
    transition: `opacity ${timeout}ms ease-in-out`,
    opacity: 1,
  },
  exiting: {
    transition: 'opacity 0ms ease-in-out',
    opacity: 0,
  },
};


class PageContainer extends React.Component {
  render() {
    const { location, children } = this.props;

    return (
      <TransitionGroup>
        <ReactTransition
          key={location.pathname}
          timeout={{
            enter: 0,
            exit: timeout,
          }}
        >
          {status => (
            <div
              style={{
                ...getTransitionStyles[status],
              }}
            >
              {children}
            </div>
          )}
        </ReactTransition>
      </TransitionGroup>
    );
  }
}

export default PageContainer;
